module.exports = {"blocks":[{"type":"sections/404","prefix":"404"}],"section_404":{"button_link":"home","links":["service","pricing","faq","driver_site","business"]}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/default/setting/404/setting.json
// module id = 479
// module chunks = 0 1 2 3 4 5